import { actionsPreprocessor } from '@/utils/redux';

const actionNames = [
  'FETCH_RESOURCES',
  'FETCH_SUCCESS',
  'FETCH_FAILED',

  'UPLOAD_RESOURCE',
  'UPLOAD_RESOURCE_SUCCESS',
  'UPLOAD_RESOURCE_FAILED',

  'DELETE_RESOURCE',
  'DELETE_RESOURCE_SUCCESS',
  'DELETE_RESOURCE_FAILED',

  'BEFORE_UPLOAD',
  'ON_REMOVE_FILE',
  'SET_FILE_NAME',
  'TABLE_CHANGE',
];

const { actions, actionTypes } = actionsPreprocessor('resources', actionNames);

export default actions;
export { actionTypes };
